export enum NavBarIndex {
  Home = 0,
  Matches = 1,
  Competitions = 2,
  Search = 3,
}
